import { createContext } from "react";
import { POSService } from "../../../services/pos.service";
import { SessionResponse } from "../types/pos.types";
import React from "react";

export interface POSContextState {
  posService: POSService;
  sessionId: string | null;
  isSessionActive: boolean;
  isLoading: boolean;
  error: Error | null;
  sessionData: SessionResponse | null;
}

export interface POSContextActions {
  startSession: (data: {
    initial_amount: number;
    denominations: {
      bills: Array<{ value: number; count: number }>;
      coins: Array<{ value: number; count: number }>;
    };
  }) => Promise<void>;
  endSession: (data: {
    session_id: string;
    final_denominations: {
      bills: Array<{ value: number; count: number }>;
      coins: Array<{ value: number; count: number }>;
    };
  }) => Promise<void>;
  checkSession: () => Promise<void>;
  clearError: () => void;
}

export interface POSContextType extends POSContextState, POSContextActions {}

export const POSContext = createContext<POSContextType | null>(null);

export const usePOSService = () => {
  const context = React.useContext(POSContext);
  if (!context) {
    throw new Error("usePOSService must be used within a POSProvider");
  }
  return context;
};
